import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
// core components

import PresentationHeader from "components/Headers/PresentationHeader2.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";
// sections for this page
// import Politica from "./Politicas/Politicas.js";


function PoliticasPrivacidadWeb() {
  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
        <PresentationHeader titulo="Políticas de Privacidad Web" />
        <div id="servicio" style={{ backgroundColor: "#f9f9f9" }}>
          <Container className="fluid">
            <Row className="justify-content-center">
              <Col md="4" style={{ marginTop: "2%" }}>
                <Card>
                  <CardBody>
                    <center>
                      <a
                        href="#privacidad-web"
                        role="button"
                        style={{ borderBottom: "none" }}
                        onClick={(e) => {
                          e.preventDefault();
                          downloadPdfFromJson("privacidad-web.json", "privacidad-web.pdf");
                        }}
                      >
                        <img
                          alt="Imagen con referencia Privacidad Web"
                          width="80px"
                          src={require("assets/img/Notaria/PDF.png")}
                        ></img>
                        <h6 className="texto">POLÍTICAS PRIVACIDAD WEB</h6>
                      </a>
                    </center>
                  </CardBody>
                </Card>
              </Col>
              <Col md="5" style={{ marginTop: "2%" }}>
                <Card>
                  <CardBody>
                    <center>
                        <img
                          alt="Imagen con Certificado Seguridad AWS"
                          width="1000em"
                          src={require("assets/img/Notaria/certificado.png")}
                        ></img>
                        <h6 className="texto">CERTIFICADO SEGURIDAD AWS</h6>
                    </center>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default PoliticasPrivacidadWeb;
